/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - baskets or berries
 */

// const VASE_CONFIG_CONTENT = findContent({
//     brand: '1800flowers',
//     contentType: 'vase_configurator',
//     query: '\\"title\\" : \\"Assorted Roses\\"',
//     reference: ['selection_tier.tier.tier_options.option', 'selection_options.option.option_info'],
// });

const findVaseConfigContent = () => (
    gql`query VaseConfigQuery {
        findContent(
            brand: "1800flowers", 
            environment: "${GRAPHQL_ENV}", 
            contentType: "vase_configurator", 
            includeRefs: [
                "selection_tier.tier.tier_options.option", 
                "selection_options.option.option_info"
            ]
        ) {
          content
        }
      }
`
);

export default findVaseConfigContent;
